import { render, staticRenderFns } from "./CommodityFunc.vue?vue&type=template&id=8ef061e8&scoped=true&"
import script from "./CommodityFunc.vue?vue&type=script&lang=js&"
export * from "./CommodityFunc.vue?vue&type=script&lang=js&"
import style0 from "./CommodityFunc.vue?vue&type=style&index=0&id=8ef061e8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ef061e8",
  null
  
)

export default component.exports